// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { FaYoutube, FaInstagram, FaFacebook, FaLinkedin, FaTwitter, FaTelegramPlane, FaWhatsapp } from 'react-icons/fa';
// import { REACT_APP_API_PORT } from '../../Api';
// import axios from 'axios';
// import Loader from '../Loader';
// import { SiThreads } from "react-icons/si"; 
// const Footer = () => {
//   const [data, setData] = useState([]);
//   const [isLoading, setisLoading] = useState(false);

//   const getData = async () => {
//     try {
//       setisLoading(true);
//       const res = await axios.get(`${REACT_APP_API_PORT}user/homepage/footer-details`);
//       setisLoading(false);
//       if (res.data.status) {
//         setData(res.data.data);
//       }
//     } catch (err) {
//       setisLoading(false);
//       console.log(err);
//     }
//   };

//   useEffect(() => {
//     getData();
//   }, []);

//   return (
//     <>
//       <Loader isLoading={isLoading} />
//       <footer className="bg-background-back1 border-t border-gray-800">
//         <div className="max-w-screen-xl mx-auto px-4 pt-5 pb-5 text-center text-white">

//           {/* Footer Links */}
//           <div className="flex flex-wrap justify-center gap-2 text-sm lg:text-md">
//             {data?.website_name || "© 2024 Next Future AI"}
//             {data?.page1_name && (
//               <>
//                 <span>|</span>
//                 <Link to={data?.page1_url} className="hover:text-primary">
//                   {data?.page1_name}
//                 </Link>
//               </>
//             )}
//             {data?.page2_name && (
//               <>
//                 <span>|</span>
//                 <Link to={data?.page2_url} className="hover:text-primary">
//                  {data?.page2_name}
//                 </Link>
//               </>
//             )}
//             {data?.page3_name && (
//               <>
//                 <span>|</span>
//                 <Link to={data?.page3_url} className="hover:text-primary">
//                  {data?.page3_name}
//                 </Link>
//               </>
//             )}
//             {data?.page4_name && (
//               <>
//                 <span>|</span>
//                 <Link to={data?.page4_url} className="hover:text-primary">
//                   {data?.page4_name}
//                 </Link>
//               </>
//             )}
//           </div>

//           {/* Social Media Icons */}
//           <div className="flex flex-wrap justify-center items-center gap-4 py-4 w-full mb-16 lg:mb-0">
//             {data?.youtube_link && (
//               <a href={data?.youtube_link} target="_blank" rel="noopener noreferrer" className="block w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-gray-700 hover:bg-[#FF0000]">
//                 <FaYoutube className="text-white text-2xl" />
//               </a>
//             )}
//             {data?.instagram_link && (
//               <a href={data?.instagram_link} target="_blank" rel="noopener noreferrer" className="block w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-gray-700 hover:bg-[#E1306C]">
//                 <FaInstagram className="text-white text-2xl" />
//               </a>
//             )}
//             {data?.facebook_link && (
//               <a href={data?.facebook_link} target="_blank" rel="noopener noreferrer" className="block w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-gray-700 hover:bg-[#1877F2]">
//                 <FaFacebook className="text-white text-2xl" />
//               </a>
//             )}
//             {data?.linkedin_link && (
//               <a href={data?.linkedin_link} target="_blank" rel="noopener noreferrer" className="block w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-gray-700 hover:bg-[#0A66C2]">
//                 <FaLinkedin className="text-white text-2xl" />
//               </a>
//             )}
//             {data?.twitter_link && (
//               <a href={data?.twitter_link} target="_blank" rel="noopener noreferrer" className="block w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-gray-700 hover:bg-[#1DA1F2]">
//                 <FaTwitter className="text-white text-2xl" />
//               </a>
//             )}

//             {data?.whatsapp_link && (
//               <a
//                 href={data?.whatsapp_link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="block w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-gray-700 hover:bg-[#25D366]"
//               >
//                 <FaWhatsapp className="text-white text-2xl" />
//               </a>
//             )}

//             {data?.telegram_link && (
//               <a
//                 href={data?.telegram_link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="block w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-gray-700 hover:bg-[#0088cc]"
//               >
//                 <FaTelegramPlane className="text-white text-2xl" />
//               </a>
//             )}

//             {data?.threads_link && (
//               <a
//                 href={data?.threads_link}
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="block w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-gray-700 hover:bg-black hover:border"
//               >
//                 <SiThreads className="text-white text-2xl" />
//               </a>
//             )}
//           </div>


//         </div>
//       </footer>
//     </>
//   );
// };

// export default Footer;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaYoutube, FaInstagram, FaFacebook, FaLinkedin, FaTwitter, FaTelegramPlane, FaWhatsapp } from 'react-icons/fa';
import { SiThreads } from "react-icons/si";
import axios from "axios";
import { REACT_APP_API_PORT } from "../../Api";
import Loader from "../Loader";
import useNewsletter from "./useNewsletter";


const Footer = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const {
  email,
  setEmail,
  message,
  isLoading1,
  subscribe
} = useNewsletter();


  const getData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/footer-details`
      );
      if (res.data.status) setData(res.data.data);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Loader isLoading={isLoading} />

    <footer className="bg-black pb-[90px] md:pb-0">

        <div className="max-w-7xl mx-auto">
          <div className=" border-t border-white/10 my-10"></div>
        </div>

        <div className="max-w-7xl mx-auto px-6  pb-4 text-white">


          {/* 🔹 TOP GRID */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">

            {/* BRAND */}
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-black font-bold">
                  NFA
                </div>
                <h3 className="text-lg sm:text-xl font-extrabold tracking-wide">
              NEXT FUTURE{" "}
              <span className="text-[#f55fff]">AI</span>
            </h3>
              </div>

              <p className="text-[#ffffff80] text-sm leading-relaxed mb-6 max-w-xs">
                Empowering learners to master AI tools and build successful
                careers in the AI-driven world.
              </p>

              {/* SOCIAL ICONS */}
             <div className="flex gap-3">

            {data?.youtube_link && (
              <a
                href={data.youtube_link}
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#FF0000]
                  flex items-center justify-center transition"
              >
                <FaYoutube />
              </a>
            )}
            
            {data?.instagram_link && (
              <a
                href={data.instagram_link}
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#E1306C]
                  flex items-center justify-center transition"
              >
                <FaInstagram />
              </a>
            )}

                         {data?.facebook_link && (
               <a href={data?.facebook_link} target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#FF0000]
                  flex items-center justify-center transition"
              >
                 <FaFacebook />
               </a>
             )}

            {data?.linkedin_link && (
              <a
                href={data.linkedin_link}
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#0A66C2]
                  flex items-center justify-center transition"
              >
                <FaLinkedin />
              </a>
            )}

            {data?.twitter_link && (
              <a
                href={data.twitter_link}
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#1DA1F2]
                  flex items-center justify-center transition"
              >
                <FaTwitter />
              </a>
            )}

             {data?.whatsapp_link && (
              <a
                href={data.whatsapp_link}
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#25D366]
                  flex items-center justify-center transition"
              >
                <FaWhatsapp />
              </a>
            )}

             {data?.telegram_link && (
              <a
                href={data.telegram_link}
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#0088cc]
                  flex items-center justify-center transition"
              >
                <FaTelegramPlane />
              </a>
            )}

            {data?.threads_link && (
              <a
                href={data.threads_link}
                target="_blank"
                rel="noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 hover:bg-white hover:text-black
                  flex items-center justify-center transition"
              >
                <SiThreads />
              </a>
            )}

           

           

          </div>

            </div>

            {/* QUICK LINKS */}
            <div>
             <h4 className="text-[15px] font-semibold mb-4">
            Quick Links
          </h4>


              <ul className="space-y-3 text-sm text-[#ffffff80]">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/news">News</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
                <li>
                  <a
                    href="https://www.whatsapp.com/channel/0029Vb5TDJXHbFUy2QPDL442"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Join Our Community
                  </a>
                </li>
                <li>
                  <a
                    href="https://nextfutureai.com/ai-prompts "
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Satyam AI Prompts
                  </a>
                </li>
                 <li>
                  <a
                    href="https://nextfutureai.com/all-guide "
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    AI Resource Hub
                  </a>
                </li>

              </ul>
            </div>

            {/* RESOURCES */}
            <div>
               <h4 className="text-[15px] font-semibold mb-4">
            Programs
          </h4>
              <ul className="space-y-3 text-sm text-[#ffffff80]">
                {/* <li><Link to="/community">AI Community</Link></li> */}
                
                <li><Link to="/courses">Courses</Link></li>
                <li><Link to="/prompts">Prompts</Link></li>
                {/* <li><Link to="/prompts-bundle">Prompts Bundle</Link></li> */}
                <li><Link to="/memberships">Memberships</Link></li>
                <li><Link to="/training">AI Trainings</Link></li>
                <li><Link to="/workshops">AI Workshop</Link></li>
              </ul>
            </div>

            {/* NEWSLETTER */}
            <div>

               <h4 className="text-[15px] font-semibold mb-4">
            Support Email 
          </h4>
               <p className="text-sm text-[#ffffff80] mb-4">
              support@nextfutureai.in 
            </p>

            <h4 className="text-[15px] font-semibold mb-4">
            Stay Updated
          </h4>

            <p className="text-sm text-[#ffffff80] mb-4">
              Join our newsletter to get the latest updates straight to your inbox.
            </p>

            <form onSubmit={subscribe} className="flex items-center gap-3">

  {/* 🔥 INPUT BOX */}
  <div className="relative flex-1 bg-[#0b0b0f] border border-white/10 rounded-xl">
    
    {/* MAIL ICON */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-white/40 pointer-events-none"
    >
      <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7"></path>
      <rect x="2" y="4" width="20" height="16" rx="2"></rect>
    </svg>

    {/* INPUT */}
    <input
      type="email"
      required
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Your email"
      className="
        bg-transparent
        pl-10 pr-4 py-3
        text-sm text-white w-full
        focus:outline-none
        placeholder:text-white/40
      "
    />
  </div>

  {/* 🔥 BUTTON */}
  <button
    type="submit"
    disabled={isLoading1}
    className="
      group
      px-5 py-3
      rounded-xl
      bg-gradient-to-br from-[#ff3366] to-[#9443ff]
      hover:brightness-110
      transition
      flex items-center justify-center
    "
  >
    {isLoading1 ? (
      "..."
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-5 h-5 text-white transition-transform group-hover:translate-x-1"
      >
        <path d="M5 12h14" />
        <path d="m12 5 7 7-7 7" />
      </svg>
    )}
  </button>

</form>




            {message && (
              <p
                className={`mt-2 text-xs ${
                  message.type === "success"
                    ? "text-green-400"
                    : "text-red-400"
                }`}
              >
                {message.text}
              </p>
            )}
          </div>

          </div>

          {/* 🔹 DIVIDER */}
          <div className="border-t border-white/10 mt-20 mb-4" />

          {/* 🔹 BOTTOM BAR */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-[#ffffff80]">
            <p>© 2026 NextFuture AI. All rights reserved.</p>

            <div className="flex gap-6">
              <Link to="/terms">Terms & Conditions</Link>
              <Link to="/privacy">Privacy Policy</Link>
              {/* <Link to="/refund">Refund Policy</Link> */}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
